var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Dev-switch",on:{"click":_vm.toggleDev}},[_c('iconBug',{class:[{'Dev-switch-on':this.$store.state.showDebug}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }